export default __webpack_public_path__ + "static/media/habrImg1.bed05461.png";